const ApiError = (langData:any, code:string) => {
    const message = (langData&&langData.GLB_API_FAIL_DESC_00) + " [" + code + "]";
    if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent("app:api-error", { detail: { message } }));
        return;
    }
    alert(message);
}
export default ApiError;